import axios from "axios";
import { getHeaders } from "./headers";
import { IProperty } from "../typos/properties";

export async function getAdsToApprove() {
  const headers = await getHeaders();

  const { data }: { data: IProperty[] } = await axios.get(
    `${process.env.REACT_APP_API_URL}/v1/advertisements/toapprove`,
    headers,
  );

  return data;
}

export async function updateAdsStatus(ads: { id: string }[], status: string) {
  const headers = await getHeaders();

  const { data }: { data: IProperty[] } = await axios.put(
    `${process.env.REACT_APP_API_URL}/v1/advertisements/status`,
    {
      advertisements: ads,
      status,
    },
    headers,
  );

  return data;
}
